class HeaderToggle extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger () {
    if (this.els.checkbox.exists) {
      this.els.checkbox.element.checked = !this.els.checkbox.element.checked
    }

    this.externalEls.overlay.element.setAttribute('aria-hidden', 'false')

    let url = '/'
    if (this.els.checkbox.element.checked) {
      url = `${this.dataset.toggleUrl}`
    }

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const content = doc.querySelector('#MainContent')
        const mainElement = document.querySelector('#MainContent')

        mainElement.innerHTML = content.innerHTML
      })
      .catch(() => {})

    setTimeout(() => {
      this.externalEls.overlay.element.setAttribute('aria-hidden', 'true')
    }, 2000)
  }
}

if (!customElements.get('header-toggle')) {
  customElements.define('header-toggle', HeaderToggle)
}
